import styled from "styled-components";
import evianLogo from "../../../assets/images/evian_red_logo.png";

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 18px;
`;

const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  justify-content: center;

  img {
    height: 100px;

    @media screen and (max-width: 768px) {
      height: 80px;
    }

    @media screen and (max-width: 480px) {
      height: 60px;
    }

    @media screen and (max-width: 320px) {
      height: 40px;
    }
  }
`;

export const EvianFormHeader = () => {
    return (
        <Header>
            <Brand>
                <img src={evianLogo} alt="evian" />
            </Brand>
        </Header>
    );
};